import { reactive as i, watch as n, provide as c, inject as s } from "vue";
const e = Symbol("dsListContext");
function u(o = {}) {
  const t = i({
    border: !1
  });
  n(o.border, (r) => {
    t.border = r;
  }, { immediate: !0 }), c(e, t);
}
function a() {
  return s(e, null);
}
export {
  u as createListProvider,
  e as listContextKey,
  a as useListContext
};
//# sourceMappingURL=design-system.es34.js.map
